import { Test } from "../types/test.types";

import { TestProgressStatus } from "@shared/enums/test.enum";
import theme from "@shared/utils/themeColors";
import Image01 from "../../../images/user-28-01.jpg";
import Image02 from "../../../images/user-28-02.jpg";
import Image03 from "../../../images/user-28-03.jpg";
import {
  getStatusBadgeClass,
  getStatusText,
} from "../../../shared/utils/test.utils";

const defaultUsers = [
  {
    id: "1",
    name: "User 01",
    thumbnailUrl: Image01,
  },
  {
    id: "2",
    name: "User 02",
    thumbnailUrl: Image02,
  },
  {
    id: "3",
    name: "User 03",
    thumbnailUrl: Image03,
  },
];

interface TestCardProps {
  test: Test;
  onStart: (testId: string, resume?: boolean) => void;
}

export const TestCard = ({ test, onStart }: TestCardProps) => {
  const hasProgress =
    test.currentProgress &&
    test.currentProgress.questionsAnswered &&
    test.currentProgress.questionsAnswered > 0;
  const progressPercentage = hasProgress
    ? Math.round(
        (test.currentProgress!.questionsAnswered! / test.totalQuestions!) * 100
      )
    : 0;

  return (
    <div
      className={`col-span-full sm:col-span-6 xl:col-span-4 ${theme.bg.primary} shadow-sm rounded-xl`}
    >
      <div className="flex flex-col h-full p-5">
        <header>
          <div className="flex items-center justify-between">
            <div className="flex items-center">
              <div
                className={`text-xs inline-flex font-medium rounded-full text-center px-2.5 py-1 ${getStatusBadgeClass(
                  test.status
                )}`}
              >
                {getStatusText(test.status)}
              </div>
            </div>
            <div className="flex -space-x-3 -ml-0.5">
              {(test.recentUsers?.length ? test.recentUsers : defaultUsers).map(
                (user, index) => (
                  <img
                    key={test.id + "_" + user.id}
                    className="rounded-full border-2 border-white box-content"
                    src={
                      user?.thumbnailUrl ||
                      `https://ui-avatars.com/api/?name=${user?.name}`
                    }
                    width="28"
                    height="28"
                    alt={user.name}
                  />
                )
              )}
            </div>
          </div>
        </header>
        <div className="grow mt-2">
          <h2 className="text-lg font-semibold text-slate-800 dark:text-slate-100 mb-1">
            {test.name}
          </h2>
          <div className="text-sm">Total Questions: {test.totalQuestions}</div>
          {test.status === TestProgressStatus.COMPLETED && (
            <div className="text-sm text-emerald-600">Score: {test.score}%</div>
          )}
          {hasProgress && test.status !== TestProgressStatus.COMPLETED ? (
            <div className="">
              <div className="w-full bg-gray-200 rounded-full mt-1 overflow-hidden">
                <div
                  className={`${theme.bg.brand} h-2 rounded-full`}
                  style={{ width: `${progressPercentage}%` }}
                />
              </div>

              <div className="flex justify-between text-sm text-gray-600 dark:text-gray-300">
                <span>Answered: {test.currentProgress!.questionsAnswered}</span>
                <span>{progressPercentage}%</span>
              </div>
            </div>
          ) : (
            ""
          )}
        </div>
        <footer className="mt-5">
          <div className="flex flex-wrap justify-end items-center">
            {test.status === TestProgressStatus.COMPLETED ? (
              <>
                <button
                  onClick={() => onStart(test.id)}
                  className={`text-sm font-medium ${theme.text.brand}`}
                >
                  View Results →
                </button>
              </>
            ) : hasProgress ? (
              <>
                <button
                  onClick={() => onStart(test.id)}
                  className={`text-sm font-medium ${theme.text.brand}`}
                >
                  Continue →
                </button>
              </>
            ) : (
              <>
                <button
                  onClick={() => onStart(test.id)}
                  className={`text-sm font-medium ${theme.text.brand}`}
                >
                  Start Test →
                </button>
              </>
            )}
          </div>
        </footer>
      </div>
    </div>
  );
};
